export default {
  previousPage: {
    id: 'buyback_common_previous_page',
    defaultMessage: 'Back to previous page',
  },
  stepperClose: {
    id: 'buyback_common_stepper_close',
    defaultMessage: 'Close',
  },
  stepperCompleted: {
    id: 'buyback_common_stepper_completed',
    defaultMessage: 'Completed',
  },
  stepperCurrent: {
    id: 'buyback_common_stepper_current',
    defaultMessage: 'Current',
  },
  categoryNavigationTitle: {
    id: 'buyback_recycling_funnel_navigation_title',
    defaultMessage: 'Recycling',
  },
  stepCategory: {
    id: 'buyback_recycling_step_category',
    defaultMessage: 'Category',
  },
  stepDevice: {
    id: 'buyback_recycling_funnel_device_title',
    defaultMessage: 'Device',
  },
  stepShippingLabel: {
    id: 'buyback_recycling_confirmation_header',
    defaultMessage: 'Shipping label',
  },
  categoryTitle: {
    id: 'buyback_recycling_category_title',
    defaultMessage: 'What kind of device do you want to recycle?',
  },
  categorySmartphone: {
    id: 'buyback_recycling_funnel_category_smartphone',
    defaultMessage: 'Smartphone',
  },
}
